import { resolveComponent as P, openBlock as a, createElementBlock as g, createBlock as N, withCtx as u, createTextVNode as p, toDisplayString as x, createCommentVNode as C, createVNode as d, createElementVNode as c, withModifiers as I, resolveDynamicComponent as J, computed as S, unref as r, ref as M, onMounted as O, Transition as z, normalizeClass as U, Fragment as B, renderList as D, watch as Q, onUnmounted as H, withKeys as q } from "vue";
import { CdrLink as R, CdrText as A, CdrButton as T, IconXSm as Z, CdrAccordion as ee, CdrModal as ne, IconAccountProfile as F, IconCheckSm as Y, IconXLg as te } from "@rei/cedar";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.reduce.js";
import "date-fns";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { tabbable as ie } from "tabbable";
const G = {
  methods: {
    // Sends analytics click tracking event
    sendClickAnalytics(e) {
      !window || !window.metrics || window.metrics.link(e);
    }
  }
};
const E = (e, t) => {
  const i = e.__vccOpts || e;
  for (const [o, f] of t)
    i[o] = f;
  return i;
}, oe = {
  name: "MembershipInfoRewardsDetails",
  components: {
    CdrLink: R,
    CdrText: A
  },
  mixins: [G],
  props: {
    user: {
      type: Object,
      default: null
    },
    dividendBalance: {
      type: String,
      required: !0
    },
    shouldShowMessage: {
      type: Boolean,
      default: !1
    },
    rewardsMessage: {
      type: String,
      required: !0
    }
  },
  methods: {
    sendAnalytics(e) {
      this.sendClickAnalytics({
        linkName: e
      });
    }
  }
}, se = {
  key: 1,
  "data-ui": "membership-info-rewards"
}, ae = {
  class: "rewards-amount"
};
function le(e, t, i, o, f, m) {
  const _ = P("CdrText"), y = P("CdrLink");
  return a(), g("div", null, [i.user.membership.memberNumber ? (a(), N(_, {
    key: 0,
    "data-ui": "membership-info-number"
  }, {
    default: u(() => [p(" Member number: #" + x(i.user.membership.memberNumber), 1)]),
    _: 1
  })) : C("", !0), i.dividendBalance ? (a(), g("div", se, [d(_, {
    class: "member-rei-rewards"
  }, {
    default: u(() => [t[1] || (t[1] = p(" Total REI Rewards: ")), c("span", ae, x(i.dividendBalance), 1)]),
    _: 1
  }), c("div", null, [d(y, {
    modifier: "standalone",
    href: "/account/member-rewards",
    "data-ui": "login-module-membership-details",
    onClick: t[0] || (t[0] = I((w) => m.sendAnalytics("login_module:your rewards activity"), ["stop"]))
  }, {
    default: u(() => t[2] || (t[2] = [p(" Your rewards activity ")])),
    _: 1
  })]), i.shouldShowMessage ? (a(), N(_, {
    key: 0,
    class: "dividend-message"
  }, {
    default: u(() => [p(x(i.rewardsMessage), 1)]),
    _: 1
  })) : C("", !0)])) : C("", !0)]);
}
const re = /* @__PURE__ */ E(oe, [["render", le], ["__scopeId", "data-v-bd607b93"]]), ce = {
  name: "MembershipInfo",
  components: {
    MembershipInfoRewardDetails: re
  },
  props: {
    user: {
      type: Object,
      default: null
    },
    componentName: {
      type: String,
      default: "MembershipInfoRewardDetails"
    },
    dividendBalance: {
      type: String,
      required: !0
    },
    shouldShowMessage: {
      type: Boolean,
      default: !1
    },
    rewardsMessage: {
      type: String,
      required: !0
    }
  }
};
function de(e, t, i, o, f, m) {
  return a(), g("div", null, [(a(), N(J(i.componentName), {
    user: i.user,
    "dividend-balance": i.dividendBalance,
    "should-show-message": i.shouldShowMessage,
    "rewards-message": i.rewardsMessage
  }, null, 8, ["user", "dividend-balance", "should-show-message", "rewards-message"]))]);
}
const ue = /* @__PURE__ */ E(ce, [["render", de]]);
const me = {
  name: "MembershipLinksJoinAlready",
  components: {
    CdrLink: R
  },
  mixins: [G],
  props: {
    user: {
      type: Object,
      default: null
    }
  },
  methods: {
    sendAnalytics(e) {
      this.sendClickAnalytics({
        linkName: e
      });
    }
  }
}, _e = {
  key: 0,
  class: "become-member"
}, fe = {
  class: "logout"
};
function ge(e, t, i, o, f, m) {
  const _ = P("CdrLink");
  return a(), g("div", null, [i.user && !i.user.membership ? (a(), g("div", _e, [d(_, {
    modifier: "standalone",
    class: "become-member--link",
    href: "/membership",
    onClick: t[0] || (t[0] = I((y) => m.sendAnalytics("login_module:join rei"), ["stop"]))
  }, {
    default: u(() => t[3] || (t[3] = [p(" Join REI ")])),
    _: 1
  }), t[6] || (t[6] = c("p", null, " Pay once and enjoy a lifetime of benefits, including FREE standard shipping, 10% back on eligible purchases and more – just for members. ", -1)), c("p", null, [t[5] || (t[5] = c("span", null, " Already a member? ", -1)), d(_, {
    modifier: "standalone",
    href: "/account",
    "data-ui": "login-module-link-membership",
    onClick: t[1] || (t[1] = I((y) => m.sendAnalytics("login_module:link your membership to your online account"), ["stop"]))
  }, {
    default: u(() => t[4] || (t[4] = [p(" Link your membership to your online account ")])),
    _: 1
  })])])) : C("", !0), c("div", fe, [d(_, {
    modifier: "standalone",
    href: "/youraccount/logout",
    class: "link_stag track-link js-sign-out-sso-action",
    "data-analytics-id": "login_module:sign_out",
    "data-ui": "login-module-sign-out",
    onClick: t[2] || (t[2] = I((y) => m.sendAnalytics("login_module:sign_out"), ["stop"]))
  }, {
    default: u(() => t[7] || (t[7] = [p(" Sign out ")])),
    _: 1
  })])]);
}
const pe = /* @__PURE__ */ E(me, [["render", ge], ["__scopeId", "data-v-63a594a1"]]);
const ye = {
  name: "MembershipLinks",
  components: {
    MembershipLinksJoinAlready: pe
  },
  props: {
    user: {
      type: Object,
      default: null
    },
    experience: {
      type: String,
      default: "control"
    },
    componentName: {
      type: String,
      default: "MembershipLinksJoinREI"
    }
  }
};
function ve(e, t, i, o, f, m) {
  return a(), N(J(i.componentName), {
    user: i.user,
    class: "membership-links"
  }, null, 8, ["user"]);
}
const be = /* @__PURE__ */ E(ye, [["render", ve], ["__scopeId", "data-v-fe987d4d"]]), we = [{
  modifier: "standalone",
  href: "/PurchaseHistoryView",
  rel: "nofollow",
  analyticsData: "login_module:purchase_history",
  dataUi: "login-module-purchase-history",
  innerHtml: "Purchase history"
}, {
  modifier: "standalone",
  href: "/account",
  analyticsData: "login_module:online_account",
  dataUi: "login-module-online-account",
  innerHtml: "Online account"
}, {
  modifier: "standalone",
  href: "/lists",
  analyticsData: "login_module:your_lists",
  dataUi: "login-module-your-lists",
  innerHtml: "Wish lists"
}, {
  modifier: "standalone",
  href: "/membership/mastercard?trackingId=account-widget",
  analyticsData: "login_module:mastercard",
  dataUi: "login-module-mastercard",
  innerHtml: '<span>REI Co-op<sup class="link__sup">&#174;</sup> Mastercard<sup class="link__sup">&#174;</sup></span>'
}], V = ["Speedier checkout", "Convenient order tracking", "Easier for members to earn and use Total REI Rewards"], K = [{
  class: "sign-in-nudge__flyout-registration-btn",
  modifier: "primary",
  action: "createAccount",
  text: "Create account",
  href: "/yaRegistration",
  data: null,
  analytics: "sign_in_nudge:create-account"
}, {
  class: "sign-in-nudge__flyout-login",
  modifier: "secondary",
  action: "login",
  text: "Sign in",
  href: "/login",
  data: "nav-level-1",
  analytics: "sign_in_nudge:login"
}], he = "/account/member-rewards", j = () => ({
  sendClickAnalytics: (t) => {
    !window || !window.metrics || window.metrics.link(t);
  }
}), ke = (e) => {
  if (!e)
    return null;
  const t = e.split("T")[0].split(/-/);
  return `${t[1]}/${t[2].trim("T")}/${t[0]}`;
};
const Ce = {
  class: "expiring-rewards",
  "data-ui": "expiring-rewards"
}, xe = {
  class: "expiring-rewards__text-container"
}, Se = {
  __name: "ExpiringRewardsNotification",
  props: {
    expirationDate: {
      type: String,
      required: !0
    }
  },
  emits: ["closed", "notificationSeen"],
  setup(e, {
    emit: t
  }) {
    const {
      sendClickAnalytics: i
    } = j(), o = e, f = t, m = S(() => ke(o.expirationDate)), _ = () => {
      i({
        linkName: "login_module:notifications_view rewards details"
      }), f("notificationSeen"), window.location.assign(he);
    }, y = () => {
      i({
        linkName: "login_module:notifications_expiring rewards message_close"
      }), f("closed");
    };
    return (w, h) => (a(), g("div", Ce, [c("div", xe, [d(r(A), {
      "data-ui": "expiring-rewards-date"
    }, {
      default: u(() => [h[1] || (h[1] = c("span", {
        class: "expiring-rewards__highlight"
      }, "Don’t lose your rewards!", -1)), p(" You have rewards expiring " + x(m.value) + ". ", 1), d(r(T), {
        class: "expiring-rewards__link",
        "data-ui": "expiring-rewards-link",
        modifier: "link",
        onClick: _
      }, {
        default: u(() => h[0] || (h[0] = [p(" View details ")])),
        _: 1
      })]),
      _: 1
    })]), d(r(T), {
      "icon-only": !0,
      "aria-label": "Close",
      "data-ui": "expiring-rewards-close",
      onClick: y
    }, {
      icon: u(() => [d(r(Z), {
        "inherit-color": ""
      })]),
      _: 1
    })]));
  }
}, Ne = /* @__PURE__ */ E(Se, [["__scopeId", "data-v-22d0d08a"]]);
const $e = {
  key: 0,
  class: "notifications__counter"
}, Ie = {
  key: 0,
  class: "notifications__content"
}, Ae = {
  key: 1,
  class: "notifications__no-alerts"
}, Le = {
  __name: "AccountSidebarNotifications",
  props: {
    notifications: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const {
      sendClickAnalytics: t
    } = j(), i = e, o = M(!1), f = M(!!localStorage.getItem("flyoutNotificationSeen")), m = M(!!localStorage.getItem("hideExpiringRewardsNotification")), _ = S(() => {
      const $ = Object.values(i.notifications || {}).reduce((v, b) => v + (b ? 1 : 0), 0);
      return {
        quantity: $,
        showCounter: $ && !f.value,
        showContent: $ && !m.value
      };
    }), y = () => {
      localStorage.setItem("flyoutNotificationSeen", !0), window.dispatchEvent(new Event("flyoutNotificationSeen")), f.value = !0;
    }, w = () => {
      t({
        linkName: o.value ? "login_module:notifications_expand" : "login_module:notifications_collapse"
      });
    }, h = () => {
      o.value && !f.value && y(), o.value = !o.value, w();
    }, L = () => {
      localStorage.setItem("hideExpiringRewardsNotification", !0), m.value = !0, y();
    };
    return O(() => {
      localStorage.removeItem("hideExpiringRewardsNotification"), _.value.showCounter && setTimeout(() => {
        o.value = !0;
      }, 250);
    }), ($, v) => (a(), N(r(ee), {
      id: "notifications",
      class: "notifications",
      level: "1",
      "border-aligned": !0,
      opened: o.value,
      "content-spacing": !0,
      "data-ui": "account-flyout-notifications",
      onAccordionToggle: h
    }, {
      label: u(() => [v[0] || (v[0] = c("span", {
        class: "notifications__header"
      }, "Notifications", -1)), _.value.showCounter ? (a(), g("span", $e, x(_.value.quantity), 1)) : C("", !0)]),
      default: u(() => [d(z, {
        mode: "out-in",
        name: "fade"
      }, {
        default: u(() => {
          var b, n;
          return [_.value.showContent ? (a(), g("div", Ie, [d(Ne, {
            "expiration-date": (n = (b = e.notifications) == null ? void 0 : b.expiringRewards) == null ? void 0 : n.expirationDate,
            onClosed: L,
            onNotificationSeen: y
          }, null, 8, ["expiration-date"])])) : (a(), g("div", Ae, [d(r(A), null, {
            default: u(() => v[1] || (v[1] = [p("No new alerts")])),
            _: 1
          })]))];
        }),
        _: 1
      })]),
      _: 1
    }, 8, ["opened"]));
  }
}, Ee = /* @__PURE__ */ E(Le, [["__scopeId", "data-v-37910d11"]]);
const Me = {
  key: 0,
  class: "account-sidebar__customer-name",
  "data-ui": "login-module-user-name"
}, Re = {
  key: 1,
  class: "account-sidebar__membership-info--date"
}, Be = {
  key: 0,
  class: "account-sidebar__membership-info"
}, De = {
  class: "account-sidebar__links"
}, Te = {
  class: "account-sidebar__mastercard-promotion"
}, Oe = {
  class: "mastercard-promotion__text",
  "data-analytics-config": "exclude"
}, je = {
  __name: "AccountSidebar",
  props: {
    user: {
      type: Object,
      default: null
    },
    open: {
      type: Boolean,
      default: !1
    },
    notifications: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["closed"],
  setup(e, {
    emit: t
  }) {
    const {
      sendClickAnalytics: i
    } = j(), o = e, f = t, m = S(() => we.slice(0, -1)), _ = S(() => {
      var n;
      return (n = o.user) != null && n.contact ? `${o.user.contact.firstName} ${o.user.contact.lastName}` : null;
    }), y = S(() => {
      var n, s;
      return (s = (n = o.user) == null ? void 0 : n.membership) != null && s.memberJoinDate ? new Date(o.user.membership.memberJoinDate).getFullYear() : null;
    }), w = S(() => {
      var n, s;
      return ((s = (n = o.user) == null ? void 0 : n.membership) == null ? void 0 : s.dividendBalance) != null ? `$${parseFloat(o.user.membership.dividendBalance).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}` : null;
    }), h = S(() => Object.keys(o.notifications).length !== 0), L = S(() => {
      var l;
      const n = /* @__PURE__ */ new Date(), s = n.getFullYear();
      return ((l = o.user) == null ? void 0 : l.membership) && n > /* @__PURE__ */ new Date(`01/01/${s}`) && n < /* @__PURE__ */ new Date(`02/14/${s}`);
    }), $ = S(() => `Co-op Member Rewards earned on ${(/* @__PURE__ */ new Date()).getFullYear() - 1} purchases will be available 2/24/25.`), v = (n) => {
      var s;
      (s = window == null ? void 0 : window.metrics) == null || s.link({
        linkName: n
      });
    }, b = () => {
      f("closed");
    };
    return (n, s) => (a(), N(r(ne), {
      id: "account-sidebar",
      class: "account-sidebar",
      "data-ui": "account-sidebar",
      "content-class": "account-sidebar__modal-content",
      "wrapper-class": "account-sidebar__modal-container",
      "overlay-class": "account-sidebar__modal-overlay",
      label: "",
      opened: e.open,
      onClosed: b
    }, {
      title: u(() => [e.user && e.user.contact && _.value ? (a(), g("div", Me, x(_.value), 1)) : C("", !0), e.user && e.user.membership && y.value ? (a(), g("div", Re, [c("span", null, "Member since " + x(y.value), 1)])) : C("", !0)]),
      default: u(() => {
        var l;
        return [e.user && e.user.membership ? (a(), g("div", Be, [e.user && e.user.membership ? (a(), N(ue, {
          key: 0,
          user: e.user,
          "dividend-balance": w.value,
          "should-show-message": L.value,
          "rewards-message": $.value
        }, null, 8, ["user", "dividend-balance", "should-show-message", "rewards-message"])) : C("", !0)])) : C("", !0), c("div", De, [c("ul", {
          class: U(["account-links", "account-links--border", {
            "account-links--gutter": (l = e.user) == null ? void 0 : l.membership
          }])
        }, [(a(!0), g(B, null, D(m.value, (k) => (a(), g("li", {
          key: k
        }, [d(r(R), {
          class: "account-sidebar__link",
          "data-analytics-config": "exclude",
          modifier: k.modifier,
          href: k.href,
          rel: k.rel || null,
          "data-ui": k.dataUi,
          onClick: (X) => v(k.analyticsData),
          innerHTML: k.innerHtml
        }, null, 8, ["modifier", "href", "rel", "data-ui", "onClick", "innerHTML"])]))), 128))], 2), h.value ? (a(), N(Ee, {
          key: 0,
          notifications: o.notifications
        }, null, 8, ["notifications"])) : C("", !0), c("div", Te, [d(r(R), {
          href: "/membership/mastercard?trackingId=account-widget",
          tabindex: "-1",
          modifier: "standalone",
          onClick: s[0] || (s[0] = I((k) => r(i)("login_module:mastercard_heading_link"), ["stop"]))
        }, {
          default: u(() => s[2] || (s[2] = [c("span", null, [p("REI Co-op"), c("sup", {
            class: "link__sup"
          }, "®"), p(" Mastercard"), c("sup", {
            class: "link__sup"
          }, "®")], -1)])),
          _: 1
        }), d(r(A), null, {
          default: u(() => [c("span", Oe, [s[4] || (s[4] = p(" Earn 5% in card rewards on all REI purchases—that’s on top of your Co-op Member Reward earned on full-price items. Terms apply. ")), d(r(R), {
            href: "/membership/mastercard?trackingId=account-widget",
            "aria-label": "Learn more about the REI Co-op Mastercard",
            onClick: s[1] || (s[1] = I((k) => r(i)("login_module:mastercard_learn_more"), ["stop"]))
          }, {
            default: u(() => s[3] || (s[3] = [p("Learn more")])),
            _: 1
          })])]),
          _: 1
        })]), d(be, {
          user: e.user,
          "component-name": "MembershipLinksJoinAlready"
        }, null, 8, ["user"])])];
      }),
      _: 1
    }, 8, ["opened"]));
  }
}, un = {
  __name: "MainComponent",
  props: {
    open: {
      type: Boolean,
      default: !1
    },
    user: {
      type: Object,
      default: null
    },
    notifications: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["key-escape", "closed"],
  setup(e, {
    emit: t
  }) {
    const i = e, o = t, f = M(), m = S(() => i.open), _ = () => {
      o("closed");
    }, y = ({
      key: w
    }) => {
      i.open && (w === "Escape" || w === "Esc") && o("key-escape");
    };
    return Q(() => i.open, (w) => {
      var h;
      if (w) {
        (h = window == null ? void 0 : window.metrics) == null || h.link({
          linkName: "login_module:open"
        });
        const L = document.querySelector(".account-nav-button");
        L && L.focus();
      }
    }), O(() => document.addEventListener("keydown", y)), H(() => document.removeEventListener("keydown", y)), (w, h) => (a(), g("div", {
      ref_key: "account",
      ref: f,
      "aria-live": "polite"
    }, [d(je, {
      open: m.value,
      user: e.user,
      notifications: e.notifications,
      onClosed: _
    }, null, 8, ["open", "user", "notifications"])], 512));
  }
};
const Ue = {
  class: "account-nav-button__span-container"
}, Pe = {
  key: 0,
  class: "account-nav-button__rewards-container",
  "data-visible": "desktop"
}, Fe = {
  key: 1,
  class: "account-nav-button__rewards-container rewards-container-mobile",
  "data-visible": "mobile"
}, mn = {
  __name: "AccountNavButton",
  props: {
    expiringRewards: {
      type: Object,
      default: null
    },
    userGreeting: {
      type: String,
      default: ""
    },
    rewardsBalance: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, i = M(!!localStorage.getItem("flyoutNotificationSeen")), o = S(() => t.expiringRewards && !i.value), f = () => {
      i.value = !!localStorage.getItem("flyoutNotificationSeen");
    }, m = () => {
      var _;
      o.value && ((_ = window == null ? void 0 : window.screen) == null ? void 0 : _.width) < 991 && (localStorage.setItem("flyoutNotificationSeen", !0), i.value = !0);
    };
    return O(() => {
      window.addEventListener("flyoutNotificationSeen", f);
    }), H(() => {
      window.removeEventListener("flyoutNotificationSeen", f);
    }), (_, y) => (a(), g("button", {
      id: "account-nav-button",
      class: U(["account-nav-button icon-button", {
        "account-nav-notification": o.value
      }]),
      "data-ui": "site-header-action-local-account",
      "data-count-label": "1",
      "data-count": "1",
      onClick: m
    }, [d(r(F), {
      class: "gnav-icon account-nav-button__icon"
    }), c("div", Ue, [d(r(A), {
      class: "account-nav-button__span",
      tag: "span",
      "data-visible": "desktop"
    }, {
      default: u(() => [p(x(e.userGreeting), 1)]),
      _: 1
    }), e.rewardsBalance ? (a(), g("div", Pe, [y[0] || (y[0] = p(" Rewards: ")), d(r(A), {
      class: "account-nav-button__rewards-span",
      tag: "span",
      "data-visible": "desktop"
    }, {
      default: u(() => [p(x(e.rewardsBalance), 1)]),
      _: 1
    })])) : C("", !0), e.rewardsBalance ? (a(), g("div", Fe, [d(r(A), {
      class: "account-nav-button__rewards-span--mobile",
      tag: "span"
    }, {
      default: u(() => [p(x(e.rewardsBalance), 1)]),
      _: 1
    })])) : C("", !0)])], 2));
  }
}, W = () => {
  const e = (i, o) => {
    let f;
    if (o) {
      const m = new URLSearchParams(o);
      return m.get("toUrl") && m.delete("toUrl"), m.get("storeId") && m.delete("storeId"), f = encodeURIComponent(`?${m.toString()}`), `/login?toUrl=${i}${f}`;
    }
    return `/login?toUrl=${i}`;
  };
  return {
    goToLogin: () => {
      if (!window || !window.location)
        return null;
      const {
        location: {
          pathname: i = "/",
          search: o
        }
      } = window;
      return e(i, o);
    }
  };
};
const He = {
  class: "account-sign-in-link__text",
  "data-visible": "mobile"
}, qe = {
  key: 1,
  class: "mobile-side-menu-nudge"
}, Je = {
  class: "sign-in-nudge__list"
}, Ye = {
  class: "sign-in-nudge__list-items"
}, Ge = {
  class: "sign-in-nudge__buttons"
}, Ve = {
  __name: "AccountLink",
  props: {
    isMobileOnly: {
      type: Boolean,
      default: !1
    },
    linkText: {
      type: String,
      default: "Sign in"
    },
    mountingPointSelector: {
      type: String,
      default: null
    }
  },
  setup(e) {
    const {
      goToLogin: t
    } = W(), {
      sendClickAnalytics: i
    } = j(), o = e, f = M(), m = S(() => !o.isMobileOnly && !o.mountingPointSelector), _ = (v) => {
      i({
        linkName: v.analytics
      }), window.location.href = t();
    }, w = {
      login: _,
      createAccount: (v) => {
        i({
          linkName: v.analytics
        }), window.location.href = v.url;
      }
    }, h = (v, b) => {
      const n = w[v];
      n ? n(b) : console.warn(`no handler found for action: ${v}`);
    }, L = () => o.mountingPointSelector ? document.querySelector(o.mountingPointSelector) : null, $ = () => {
      const v = L();
      v && (v.textContent = "", v.appendChild(f.value));
    };
    return O(() => {
      $();
    }), (v, b) => (a(), g("div", {
      ref_key: "accountLinkElement",
      ref: f
    }, [m.value ? (a(), N(r(R), {
      key: 0,
      class: "account-sign-in-link",
      "data-ui": "login-module-greeting",
      modifier: "standalone",
      "data-count-label": "1",
      "data-count": "1",
      onClick: b[0] || (b[0] = I((n) => _({
        url: "/login",
        analytics: "rei_nav:sign in"
      }), ["prevent"]))
    }, {
      default: u(() => [d(r(F), {
        class: "gnav-icon account-sign-in-link--icon"
      }), c("div", He, [d(r(A), {
        tag: "span"
      }, {
        default: u(() => b[1] || (b[1] = [p("SIGN IN")])),
        _: 1
      })]), d(r(A), {
        class: "account-sign-in-link--span",
        tag: "span",
        "data-visible": "desktop"
      }, {
        default: u(() => [p(x(e.linkText), 1)]),
        _: 1
      })]),
      _: 1
    })) : C("", !0), e.isMobileOnly ? (a(), g("div", qe, [c("div", Je, [d(r(F), {
      class: "sign-in-nudge__list-account-icon"
    }), b[2] || (b[2] = c("div", {
      class: "sign-in-nudge__list-title"
    }, [c("p", null, [c("strong", {
      class: "sign-in-nudge__text--strong"
    }, "SIGN IN"), p(" for the best experience: ")])], -1)), c("ul", Ye, [(a(!0), g(B, null, D(r(V), (n) => (a(), g("li", {
      key: n,
      class: "sign-in-nudge__list-item"
    }, [d(r(Y), {
      class: "sign-in-nudge__list-icon"
    }), p(x(n), 1)]))), 128))])]), c("div", Ge, [(a(!0), g(B, null, D(r(K), (n, s) => (a(), N(r(T), {
      key: s,
      class: U(n.class),
      "data-ui": n.data,
      modifier: n.modifier,
      onClick: (l) => h(n.action, {
        url: n.href,
        analytics: n.analytics
      })
    }, {
      default: u(() => [p(x(n.text), 1)]),
      _: 2
    }, 1032, ["class", "data-ui", "modifier", "onClick"]))), 128))])])) : C("", !0)], 512));
  }
}, _n = /* @__PURE__ */ E(Ve, [["__scopeId", "data-v-48a32cdf"]]);
const Ke = {
  class: "sign-in-nudge__flyout"
}, We = {
  class: "sign-in-nudge__flyout-close"
}, Xe = {
  class: "sign-in-nudge__list"
}, ze = {
  class: "sign-in-nudge__list-title"
}, Qe = {
  class: "sign-in-nudge__list-items"
}, Ze = {
  class: "sign-in-nudge__buttons"
}, en = {
  __name: "SignInNudge",
  props: {
    open: {
      type: Boolean,
      default: !1
    },
    trapTabInsideWidget: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["key-escape", "closed"],
  setup(e, {
    emit: t
  }) {
    const {
      goToLogin: i
    } = W(), {
      sendClickAnalytics: o
    } = j(), f = e, m = t, _ = M(), y = ({
      key: n
    }) => {
      f.open && (n === "Esc" || n === "Escape") && m("key-escape");
    }, w = (n, s) => {
      if (!f.trapTabInsideWidget)
        return;
      const l = ie(_.value), k = l.length - 1;
      if (l.length <= 1) {
        n.preventDefault();
        return;
      }
      s === "next" && n.target === l[k] && (n.preventDefault(), l[0].focus()), s === "back" && n.target === l[0] && (n.preventDefault(), l[k].focus());
    }, $ = {
      login: (n) => {
        o({
          linkName: n.analytics
        }), window.location.href = i();
      },
      createAccount: (n) => {
        o({
          linkName: n.analytics
        }), window.location.href = n.url;
      }
    }, v = (n, s) => {
      const l = $[n];
      l ? l(s) : console.warn(`no handler found for action: ${n}`);
    }, b = (n) => {
      var s;
      (s = window == null ? void 0 : window.metrics) == null || s.link({
        linkName: n
      }), m("closed");
    };
    return O(() => {
      document.addEventListener("keydown", y);
    }), H(() => {
      document.removeEventListener("keydown", y);
    }), (n, s) => e.open ? (a(), g("div", {
      key: 0,
      id: "sign-in-nudge",
      ref_key: "signInNudgeContainer",
      ref: _,
      class: "sign-in-nudge",
      "data-ui": "sign-in-nudge",
      onKeydown: [s[1] || (s[1] = q(I((l) => w(l, "next"), ["exact"]), ["tab"])), s[2] || (s[2] = q(I((l) => w(l, "back"), ["shift"]), ["tab"]))]
    }, [c("div", Ke, [c("div", We, [d(r(T), {
      "icon-only": !0,
      "aria-label": "Close sign in nudge",
      class: "sign-in-nudge__close",
      type: "button",
      onClick: s[0] || (s[0] = I((l) => b("sign_in_nudge:close"), ["stop", "prevent"]))
    }, {
      default: u(() => [d(r(te), {
        class: "cdr-button__icon",
        "inherit-color": ""
      }, {
        icon: u(() => s[3] || (s[3] = [])),
        _: 1
      })]),
      _: 1
    })]), c("div", Xe, [c("div", ze, [d(r(A), null, {
      default: u(() => s[4] || (s[4] = [c("strong", {
        class: "sign-in-nudge__text--strong"
      }, "SIGN IN", -1), p(" for the best experience: ")])),
      _: 1
    })]), c("ul", Qe, [(a(!0), g(B, null, D(r(V), (l) => (a(), g("li", {
      key: l,
      class: "sign-in-nudge__list-item"
    }, [d(r(Y), {
      class: "sign-in-nudge__list-icon"
    }), p(x(l), 1)]))), 128))])]), c("div", Ze, [(a(!0), g(B, null, D(r(K), (l, k) => (a(), N(r(T), {
      key: k,
      class: U(l.class),
      "data-ui": l.data || null,
      modifier: l.modifier,
      onClick: (X) => v(l.action, {
        url: l.href,
        analytics: l.analytics
      })
    }, {
      default: u(() => [p(x(l.text), 1)]),
      _: 2
    }, 1032, ["class", "data-ui", "modifier", "onClick"]))), 128))])])], 544)) : C("", !0);
  }
}, fn = /* @__PURE__ */ E(en, [["__scopeId", "data-v-a95b7876"]]);
export {
  un as AccountFlyout,
  _n as AccountLink,
  mn as AccountNavButton,
  fn as SignInNudge
};
